import { meta } from "../../models/meta.js";

export default function RadniNalogService(DS, $q, $http) {
    let filter = {};
    let pager = {
        currentPage: 1,
        limit: 20,
        totalItems: 0
    };

    function getPager() {
        return { ...pager };
    }

    function setPager(newPager) {
        pager = Object.assign({}, pager, newPager);
    }

    function getFilter() {
        return { ...filter };
    }

    function setFilter(newFilter) {
        filter = Object.assign({}, filter, newFilter);
    }

    function getRadniNalog(id) {
        return DS.find("RadniNalog", id).catch(error => {
            return $q.reject(error);
        });
    }

    function fetchRadneNaloge() {
        const currentPager = getPager();
        const currentFilter = getFilter();
        const pagerParams = {
            offset: (currentPager.currentPage - 1) * currentPager.limit,
            limit: currentPager.limit
        };

        const params = { ...pagerParams, ...currentFilter };

        return $q
            .when(DS.findAll("RadniNalog", params, { bypassCache: true }))
            .then(response => {
                // debugger;
                let start = parseInt(pagerParams.offset + 1);
                let end = parseInt(pagerParams.offset + response.length);
                if (meta["RadniNalog"] !== undefined) {
                    setPager({
                        totalItems: meta["RadniNalog"].count,
                        start: start,
                        end: end
                    });
                }

                return response;
            })
            .catch(error => {
                return $q.reject(error);
            });
    }

    function find(id) {
        return $q.when(DS.find("RadniNalog", id));
    }

    // function brojStranica(id) {
    //     return $q.when(DS.getMapper('dokument').brojStranica(id));
    // }

    function filterRadneNalogeBy(filter) {
        // setPredmetFilter(filter);
        // setCurrentPage(1);
        fetchDokumente();
    }

    return {
        getPager,
        setPager,
        getRadniNalog,
        setFilter,
        getFilter,
        filterRadneNalogeBy,
        fetchRadneNaloge,
        find
    };
}

RadniNalogService.$inject = ["DS", "$q", "$http"];



// WEBPACK FOOTER //
// ./app/components/radniNalog/radniNalog.service.js